import { defineStore } from 'pinia'
import { loadAvailableJsonClasses } from '@/api/requests/product/productRequests'
import { JsonClass } from '@/types/api/product/productTypes'

export const useProductStore = defineStore('product', {
    state: () => {
        return {
            availableJsonClassesState: {
                eligibility: [],
                crediting: [],
            } as Record<string, Array<object>>,
        }
    },
    getters: {
        availableJsonClasses: (state) => state.availableJsonClassesState.eligibility as JsonClass[],
        availableJsonClassesFor: (state) => (context?: string) => (state.availableJsonClassesState[context ?? 'eligibility'] ?? []) as JsonClass[],
    },
    actions: {
        async loadJsonClasses(context?: string){
            this.availableJsonClassesState[context ?? 'eligibility'] = await loadAvailableJsonClasses(context)
        },
    },
})
